import React from 'react';
import InlineSpinner from './InlineSpinner';

interface DisplayLoadingProps {
    validation: boolean;
}

const DisplayLoading: React.FC<DisplayLoadingProps> = (props) => {
    if (props.validation) {
        return (
            <InlineSpinner size={'100px'} />
        );
    }
    return null;
};
export default DisplayLoading;
